import styled from 'styled-components';

export const Container = styled.div`
  width: 80vw;
  position: relative;
`;

export const TableContainerStyle = styled.div`
  height: 70vh;
  overflow: auto;
  table {
    thead {
      position: sticky;
      top: 0px;
      background: #fff;
      z-index: 100;
      background: #f8f9fa;

      box-shadow:
        0 -1px 0 #f1f3f5,
        0 1px 0 #f1f3f5;
    }
  }
`;

export const CloseStyle = styled.div`
  position: absolute;
  display: flex;
  right: 0;
  top: 0;
  cursor: pointer;
`;

export const Title = styled.p`
  color: #25262b;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  margin-bottom: 30px;
`;

export const ErrorMessageStyle = styled.p``;

export const DescriptionStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const FileNameStyle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TabsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
`;

export const Tabs = styled.div`
  display: flex;
  gap: 2px;
  background: #f1f3f5;
  padding: 2px;
  border-radius: 4px;
  width: auto;
`;

export const Tab = styled.button`
  border-radius: 4px;

  &.active {
    background: var(--bw-white, #fff);
    box-shadow:
      0px 1px 2px 0px rgba(0, 0, 0, 0.1),
      0px 1px 3px 0px rgba(0, 0, 0, 0.05);
  }

  color: var(--bw-black, #000);

  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 16.8px */
  padding: 3.5px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Badge = styled.span`
  width: 18px;
  height: 18px;
  border-radius: 16px;
  background: ${({ color }) => color || 'var(--Gray-Gray-6, #868e96)'};
  color: white;
  leading-trim: both;
  text-edge: cap;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 1px;

  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%; /* 16.8px */
`;

export const FooterStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  margin-top: 32px;

  button:disabled {
    svg {
      path {
        fill: transparent !important;
      }
    }
  }
`;

export const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    overflow: 'hidden',
    // Stay above the page table's sticky <thead> (z-index 9 in shared Table).
    zIndex: 1001
  },
  overlay: {
    background: 'rgba(0, 0, 0, 0.30)',
    zIndex: 1000
  }
};

export const colors = {
  Completed: '#2F9E44',
  'Not started': '#868E96',
  'In progress': '#FD7E14',
  Cancelled: '#868E96',
  Failed: '#E03131'
};
